export namespace CoreCountersActions {
  export class FetchCountersEndUser {
    static readonly type = '[Core Counters] Fetch Counters';
  }
  export class DeleteCounterEndUser {
    static readonly type = '[Core Counters] Delete Counter';
    constructor(public counterId: string) {}
  }
  export class ScheduleCountersEntriesCountFetching {
    static readonly type =
      '[Core Counters] Schedule Fetch Counters Entries Count';
  }
  export class FetchCountersEntriesCount {
    static readonly type = '[Core Counters]  Fetch Counter Entries Count';
  }
  export class FetchCountersEntries {
    static readonly type = '[Core Counters]  Fetch Counter Entries';
    constructor(
      public payload: {
        counterId: string;
        viewId: string;
        skip?: number;
        limit?: number;
      },
    ) {}
  }
}
